import Trip from "./Trip";

export const Progress = {
    Trip
}